<template>
    <div class="idx-page">
      <div v-if="isIos && isWx" class="ios-wx-cont" @click="bodyClick">
        <img style="position:absolute;left:0;top:0;width:172px;" src="../assets/img/zql/download/s_ele_left.png" />
        <img style="position:absolute;right:0;top:0;width:84px;" src="../assets/img/zql/download/s_right_top.png" />
        <img style="position:absolute;right:0;top:300px;width:88px;" src="../assets/img/zql/download/s_ele_right.png" />
        <img style="position:absolute;left:0;bottom:0;width:162px;" src="../assets/img/zql/download/s_photo_girl.png" />
        <img style="position:absolute;right:0;bottom:0;width:111px;" src="../assets/img/zql/download/s_photo_boy.png" />

        <div class="ss-item">
          <img src="../assets/img/zql/download/logo_money.png" class="logo" />
          
          <div style="text-align:center;">
            <img src="../assets/img/zql/download/text_main.png" class="text-main" />
          </div>
          
          <p  style="margin-top: 50px;"></p>

          <a><span  class="down-span" >
            <img src="../assets/img/xzz.png" style="height: 20px;margin-top: 2px;" />
          </span></a>
        </div>

        <div id="weixin-tip" v-if="visibleWxTip">
          <img src="../assets/img/zql/download/live_weixin.png" alt="微信打开"/>
        </div>
      </div>
      <register v-else-if="isIos"></register>
      <downloadV2 v-else></downloadV2>
    </div>
  </template>
  
  <script>
  import downloadV2 from './downloadV2'
  import register from './register'
  
  export default {
    components: {
        downloadV2,
        register
    },
    data() {
        return {
            isIos: false,
            isWx: false,
            visibleWxTip: false,
        }
    },
    created() {
      console.log('main index page  开火车。。。。。。。。。。。。。');
      this.is_wechat_client()
      var isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      var isIphone = /(iPhone|iPad|iPod|iOS)/ig.test(navigator.userAgent)
      var iosPlatform = /^(iPhone|iPad|iPod|Pike)/ig.test(navigator.platform) 
      var ios11 = !!navigator.userAgent.match(/Intel Mac OS X/)

      if (isIos || iosPlatform || isIphone || ios11) {
        isIos = true;
      }
      this.isIos = isIos;
    },
    mounted() {
      this.is_wechat_client()
    },
    methods: {
      is_wechat_client() {
        var ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i)=="micromessenger"){
          this.isWx = true
        } else {
          this.isWx = false
        }
      },
      bodyClick() {
        this.visibleWxTip = true
      },
    }
  }
  </script>
  
  <style lang="less" scoped>
  .idx-page{
    // height: 100%;
    // width: 100%;
  }
  .ios-wx-cont{
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background:linear-gradient(0deg,rgba(255,99,27,1) 0%,rgba(254,107,29,1) 68%,rgba(255,97,52,1) 84%,rgba(254,163,14,1) 100%);
    
    .ss-item{
      position: absolute;
      top: 40px;
      left: 0;
      width: 100%;
      text-align: center;

      .logo {
        width: 150px;
        height: 150px;
        // width: 80px;
        // height: 80px;
        // border-radius: 10px;
        // margin-bottom: 40px;
        // margin-top: 30px;
      }
      .text-main {
        width: 150px;
      }
        
      a{
        display: inline-block;
        font-weight: 600;
        font-size: 16px;
        width: 250px;
        height: 38px;
        margin: 52px 0 63px;
        line-height: 38px;
        background: linear-gradient(90deg, #FEAA00 0%, #FFD105 100%);
        border-radius: 54px;
        color: #fff;
      }
      .down-span {
        width: 250px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .inviter {
        text-align: center;
        color: #fff;
      }
      .copy-inv {
        background: linear-gradient(90deg, #FEAA00 0%, #FFD105 100%);
        display: inline-block;
        padding: 0 4px;
        border-radius: 4px;
        margin-left: 4px;
        font-size: 12px;
      }
      .inv-tip {
        font-size: 12px;
        color: #fff;
      }
    }

    #weixin-tip{
      position: fixed; 
      left:0; 
      top:0; 
      background: rgba(0,0,0,0.8);
      filter:alpha(opacity=80);
      width: 100%;
      height:100%;
      z-index: 100;
      text-align: center;
    } 
    #weixin-tip p{
      text-align: center;
      margin-top: 10%; 
      padding:0 5%;
    }
    #weixin-tip img{
      margin-top: 6px;
      width: 98vw;
    }
    .dsn{
      display: none;
    }
  }
  </style>